const transferDataReducer = function (state = {}, action) {
	switch (action.type) {
		case "SET_TRANSFER_DATA":
			return state = action.payload;
		default:
			return state;
	}
};

export default transferDataReducer